"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _excluded = ["header", "body", "footer", "bodyNotice", "bodyNoticeProps", "bodyError", "bodyErrorProps"];

var _this = void 0;

/**
 * ChargeInfo.Wrapper
 * @description 计费UI组件-基本布局
 */
var Wrapper = function Wrapper(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      bodyNotice = _ref.bodyNotice,
      bodyNoticeProps = _ref.bodyNoticeProps,
      bodyError = _ref.bodyError,
      bodyErrorProps = _ref.bodyErrorProps,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var showBorder = body || footer;
  return /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperMain, others, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style.prefixCls, "-header-body-wrapper")
  }, header && /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperHeader, {
    showBorder: showBorder
  }, header), body && /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperBody, null, bodyNotice && /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperNotice, (0, _extends2["default"])({
    closable: false,
    styleType: "default"
  }, bodyNoticeProps), bodyNotice), bodyError && /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperNotice, (0, _extends2["default"])({
    closable: false,
    styleType: "error"
  }, bodyErrorProps), bodyError), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style.prefixCls, "-wrapper-body-inner")
  }, body))), footer && /*#__PURE__*/_react["default"].createElement(_style.StyledWrapperFooter, null, footer));
}.bind(void 0);

Wrapper.propTypes = {
  /**
   * 头部内容区域的内容
   */
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 中间内容区域的内容
   */
  body: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 底部内容区域的内容
   */
  footer: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 中间内容区域的提示信息
   */
  bodyNotice: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 中间内容区域的提示信息所用基础组件Notice的props
   */
  bodyNoticeProps: _propTypes["default"].object,

  /**
   * 中间内容区域的错误信息
   */
  bodyError: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * 中间内容区域的错误信息所用基础组件Notice的props
   */
  bodyErrorProps: _propTypes["default"].object
};
Wrapper.defaultProps = {};
var _default = Wrapper;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Wrapper.js
// module id = 2087
// module chunks = 6 7 17 18